// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type PdpQueryVariables = Types.Exact<{
  brandKey: Types.Scalars['String']['input'];
  productKey: Types.Scalars['String']['input'];
  catalogType?: Types.InputMaybe<Types.CatalogType>;
  orgId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isMarketplaceCatalogEnabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  displayLanguage?: Types.InputMaybe<Types.Scalars['String']['input']>;
  country?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PdpQuery = { __typename?: 'Query', getProductDetail?: { __typename?: 'Product', id?: string | null, productNumber: string, productKey: string, erpProductKey: string, isSial: boolean, status?: string | null, isMarketplace: boolean, marketplaceSellerId?: string | null, marketplaceOfferId?: string | null, hasEmproveDoc?: boolean | null, name: string, legalName?: string | null, legalNameSuffix?: string | null, displaySellerName?: string | null, description?: string | null, molecularWeight?: string | null, empiricalFormula?: string | null, linearFormula?: string | null, casNumber?: string | null, badge?: string | null, synonyms: Array<string>, materialIds: Array<string>, sdsPnoKey: string, features: Array<string>, paMessage?: string | null, catalogId?: Types.CatalogType | null, substanceCount: number, type?: string | null, customPdpId: string, erp_type?: Array<string> | null, substance: { __typename?: 'Substance', id: string, name: string }, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null, color?: string | null, logo?: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } | null, cells?: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } | null }, aliases: Array<{ __typename?: 'Alias', key: string, value: string, label: string }>, descriptions: Array<{ __typename?: 'ProductDescription', label?: string | null, values: Array<string> }>, keyAttributes?: Array<{ __typename?: 'ProductAttribute', key: string, label: string, values: Array<string> }> | null, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, label?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string, videoUrl?: string | null }>, attributes: Array<{ __typename?: 'ProductAttribute', key: string, label: string, values: Array<string>, seq?: number | null }>, compliance: Array<{ __typename?: 'Compliance', key?: string | null, label?: string | null, value?: string | null, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string }> }>, complianceReach: Array<{ __typename?: 'ComplianceReach', key?: string | null, label?: string | null, value?: string | null, casNos?: Array<string | null> | null }>, complianceJp: Array<{ __typename?: 'ComplianceJp', id?: string | null, label?: string | null, value?: string | null, seq?: number | null }>, browserMetadata?: { __typename?: 'BrowserMetadata', title?: string | null, description?: string | null, keywords?: Array<string> | null } | null, links: Array<{ __typename?: 'DocumentLink', label: string, key?: string | null, anchorTag: string, image?: string | null }>, forms?: Array<{ __typename?: 'Form', label: string, type: string, url: string }> | null, components: { __typename?: 'MappedProductComponent', kitOnly?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null, pno?: string | null, brand?: string | null, erpBrandKey?: string | null, erpPnoKey?: string | null } | null> | null, kitSoldSeparate?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null, pno?: string | null, brand?: string | null, erpBrandKey?: string | null, erpPnoKey?: string | null } | null> | null, analyte?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null } | null> | null, solvent?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null } | null> | null, bulletin?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null } | null> | null }, productCategories: Array<{ __typename?: 'ProductCategory', category: string, url: string } | null>, relatedProducts: Array<{ __typename?: 'RelatedProduct', type: string, productId: string }>, productRating?: { __typename?: 'ProductRating', ratingEnabled?: boolean | null } | null, txnBadge?: { __typename?: 'TxnBadge', label: string, priority: number, salesOrgIds: Array<string>, type: string } | null } | null };

export type PdpFieldsFragment = { __typename?: 'Product', id?: string | null, productNumber: string, productKey: string, erpProductKey: string, isSial: boolean, status?: string | null, isMarketplace: boolean, marketplaceSellerId?: string | null, marketplaceOfferId?: string | null, hasEmproveDoc?: boolean | null, name: string, legalName?: string | null, legalNameSuffix?: string | null, displaySellerName?: string | null, description?: string | null, molecularWeight?: string | null, empiricalFormula?: string | null, linearFormula?: string | null, casNumber?: string | null, badge?: string | null, synonyms: Array<string>, materialIds: Array<string>, sdsPnoKey: string, features: Array<string>, paMessage?: string | null, catalogId?: Types.CatalogType | null, substanceCount: number, type?: string | null, customPdpId: string, erp_type?: Array<string> | null, substance: { __typename?: 'Substance', id: string, name: string }, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null, color?: string | null, logo?: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } | null, cells?: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } | null }, aliases: Array<{ __typename?: 'Alias', key: string, value: string, label: string }>, descriptions: Array<{ __typename?: 'ProductDescription', label?: string | null, values: Array<string> }>, keyAttributes?: Array<{ __typename?: 'ProductAttribute', key: string, label: string, values: Array<string> }> | null, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, label?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string, videoUrl?: string | null }>, attributes: Array<{ __typename?: 'ProductAttribute', key: string, label: string, values: Array<string>, seq?: number | null }>, compliance: Array<{ __typename?: 'Compliance', key?: string | null, label?: string | null, value?: string | null, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string }> }>, complianceReach: Array<{ __typename?: 'ComplianceReach', key?: string | null, label?: string | null, value?: string | null, casNos?: Array<string | null> | null }>, complianceJp: Array<{ __typename?: 'ComplianceJp', id?: string | null, label?: string | null, value?: string | null, seq?: number | null }>, browserMetadata?: { __typename?: 'BrowserMetadata', title?: string | null, description?: string | null, keywords?: Array<string> | null } | null, links: Array<{ __typename?: 'DocumentLink', label: string, key?: string | null, anchorTag: string, image?: string | null }>, forms?: Array<{ __typename?: 'Form', label: string, type: string, url: string }> | null, components: { __typename?: 'MappedProductComponent', kitOnly?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null, pno?: string | null, brand?: string | null, erpBrandKey?: string | null, erpPnoKey?: string | null } | null> | null, kitSoldSeparate?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null, pno?: string | null, brand?: string | null, erpBrandKey?: string | null, erpPnoKey?: string | null } | null> | null, analyte?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null } | null> | null, solvent?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null } | null> | null, bulletin?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null } | null> | null }, productCategories: Array<{ __typename?: 'ProductCategory', category: string, url: string } | null>, relatedProducts: Array<{ __typename?: 'RelatedProduct', type: string, productId: string }>, productRating?: { __typename?: 'ProductRating', ratingEnabled?: boolean | null } | null, txnBadge?: { __typename?: 'TxnBadge', label: string, priority: number, salesOrgIds: Array<string>, type: string } | null };

export const PdpFieldsFragmentDoc = gql`
    fragment PDPFields on Product {
  id
  productNumber
  productKey
  erpProductKey
  isSial
  status
  isMarketplace
  marketplaceSellerId
  marketplaceOfferId
  hasEmproveDoc
  substance {
    id
    name
  }
  brand {
    key
    erpKey
    name
    logo {
      altText
      smallUrl
      mediumUrl
      largeUrl
    }
    cells {
      altText
      smallUrl
      mediumUrl
      largeUrl
    }
    color
  }
  aliases {
    key
    value
    label
  }
  name
  legalName
  legalNameSuffix
  displaySellerName
  description
  descriptions {
    label
    values
  }
  molecularWeight
  empiricalFormula
  linearFormula
  casNumber
  badge
  keyAttributes {
    key
    label
    values
  }
  images {
    altText
    label
    smallUrl
    mediumUrl
    largeUrl
    videoUrl
  }
  synonyms
  attributes {
    key
    label
    values
    seq
  }
  materialIds
  compliance {
    key
    label
    value
    images {
      altText
      smallUrl
      mediumUrl
      largeUrl
    }
  }
  complianceReach {
    key
    label
    value
    casNos
  }
  complianceJp {
    id
    label
    value
    seq
  }
  browserMetadata {
    title
    description
    keywords
  }
  sdsPnoKey
  links {
    label
    key
    anchorTag
    image
  }
  features
  forms {
    label
    type
    url
  }
  paMessage
  catalogId
  components {
    kitOnly {
      value
      pId
      pno
      brand
      erpBrandKey
      erpPnoKey
    }
    kitSoldSeparate {
      value
      pId
      pno
      brand
      erpBrandKey
      erpPnoKey
    }
    analyte {
      value
      pId
    }
    solvent {
      value
      pId
    }
    bulletin {
      value
      pId
    }
  }
  substanceCount
  productCategories {
    category
    url
  }
  relatedProducts {
    type
    productId
  }
  type
  customPdpId
  productRating {
    ratingEnabled
  }
  erp_type
  txnBadge {
    label
    priority
    salesOrgIds
    type
  }
}
    `;
export const PdpDocument = gql`
    query PDP($brandKey: String!, $productKey: String!, $catalogType: CatalogType, $orgId: String, $isMarketplaceCatalogEnabled: Boolean, $displayLanguage: String, $country: String) {
  getProductDetail(
    input: {brandKey: $brandKey, productKey: $productKey, catalogType: $catalogType, orgId: $orgId, isMarketplaceCatalogEnabled: $isMarketplaceCatalogEnabled, displayLanguage: $displayLanguage, country: $country}
  ) {
    ...PDPFields
  }
}
    ${PdpFieldsFragmentDoc}`;
export type PdpComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PdpQuery, PdpQueryVariables>, 'query'> & ({ variables: PdpQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PdpComponent = (props: PdpComponentProps) => (
      <ApolloReactComponents.Query<PdpQuery, PdpQueryVariables> query={PdpDocument} {...props} />
    );
    

/**
 * __usePdpQuery__
 *
 * To run a query within a React component, call `usePdpQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpQuery({
 *   variables: {
 *      brandKey: // value for 'brandKey'
 *      productKey: // value for 'productKey'
 *      catalogType: // value for 'catalogType'
 *      orgId: // value for 'orgId'
 *      isMarketplaceCatalogEnabled: // value for 'isMarketplaceCatalogEnabled'
 *      displayLanguage: // value for 'displayLanguage'
 *      country: // value for 'country'
 *   },
 * });
 */
export function usePdpQuery(baseOptions: Apollo.QueryHookOptions<PdpQuery, PdpQueryVariables> & ({ variables: PdpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpQuery, PdpQueryVariables>(PdpDocument, options);
      }
export function usePdpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpQuery, PdpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpQuery, PdpQueryVariables>(PdpDocument, options);
        }
export function usePdpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdpQuery, PdpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpQuery, PdpQueryVariables>(PdpDocument, options);
        }
export type PdpQueryHookResult = ReturnType<typeof usePdpQuery>;
export type PdpLazyQueryHookResult = ReturnType<typeof usePdpLazyQuery>;
export type PdpSuspenseQueryHookResult = ReturnType<typeof usePdpSuspenseQuery>;
export type PdpQueryResult = Apollo.QueryResult<PdpQuery, PdpQueryVariables>;